// extracted by mini-css-extract-plugin
export var createdDate = "_je-1";
export var divider = "_je-2";
export var headerDivider = "_je-3";
export var messagesCard = "_je-0";
export var messagesContainer = "_je-7";
export var messagesContainerWrapper = "_je-4";
export var pointerCapturingButtonBoxes = "_je-a";
export var showLeftPanelButton = "_je-9";
export var showMoreButton = "_je-c";
export var showMoreButtonContainer = "_je-b";
export var summaryTitle = "_je-6";
export var systemMessageCardWrapper = "_je-d";
export var topButtons = "_je-8";
export var withPadding = "_je-5";